export default __webpack_public_path__ + "static/media/capsule-unpaid.12f7eca4.png";